import React from 'react'
import { HeadXL } from '../../../Components/Typography/Text.styles'
import { AcademyEventsTabs } from './components/AcademyEventsTabs'

const AcademyEvents: React.FC = () => {
  return (
    <>
    <HeadXL>Event Schedule</HeadXL>
    <AcademyEventsTabs />
    </>
  )

}

export default AcademyEvents